<ng-template #comparisonModalContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-comparison-title" i18n="comparison_modal|@@choose_an_old_tchek">Choisissez un
      Tchek</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-striped table-bordered table-sm" *ngIf="tcheks.length; else noTcheks">
      <thead>
        <tr>
          <th>Action</th>
          <th i18n="monitoring|@@date">Date</th>
          <th i18n="monitoring|@@hour">Heure</th>
          <th i18n="monitoring|@@Device">Borne</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tchek of tcheks">
          <td>
            <input type="radio" name='compare' value="tchek.id" (change)="toggleCheckbox($event, tchek)"
              [checked]="tchek.checked">
          </td>
          <td>{{tchek.date | date:'mediumDate'}}</td>
          <td>{{tchek.date | date:'HH:mm:ss'}}</td>
          <td>{{tchek.devicePtr.serialNumber}}</td>
        </tr>
      </tbody>
    </table>
    <ng-template #noTcheks>
      <div class="mx-auto text-secondary text-center" style="font-size:2.5em;" i18n="comparison_modal@@PastTchek">
        Aucun Tchek antérieur.
      </div>
    </ng-template>
  </div>
  <div class="modal-footer">
    <button *ngIf="tcheks.length" type="button" class="btn btn-info" (click)="c()"
      i18n="comparison_modal@@compare">Comparer</button>
    <button *ngIf="!tcheks.length" type="button" class="btn btn-outline-light text-muted"
      i18n="comparison_modal@@compare" disabled>Comparer</button>
  </div>
</ng-template>
<button *ngIf="tcheks.length  >0  &&  button !== 'fast' && button !== 'fastTrack'" type="button"
  class="btn mb-2 btn-sm btn-info" (click)="openComparisonModal(comparisonModalContent)"
  i18n="comparison_modal@@compare">Comparer
  ce scan</button>
<button *ngIf="tcheks.length  >0 && button === 'fast' && previousScan" type="button" class="btn mb-2 btn-sm btn-info"
  (click)="openComparisonLastScan()" i18n="comparison_modal@@comparefast">Comparaison Rapide</button>
<button *ngIf="tcheks.length  >0 && button === 'fastTrack' && previousScan" type="button"
  class="btn mb-2 btn-sm btn-info w-100" (click)="openComparisonLastScan()"
  i18n="comparison_modal@@comparefast">Comparaison Rapide</button>


// WEBPACK FOOTER //
// ./src/app/element/comparison-modal/comparison-modal.component.html